(() => {
  const threshold = 34;
  let ticking = false;

  function updateHeaderState() {
    ticking = false;

    const body = document.body;
    const header = document.querySelector('.section-header');
    if (!body) return;

    const isHome = body.classList.contains('template-index');
    const shouldBeSolid = !isHome || window.scrollY > threshold;

    body.classList.toggle('ah-home-header-scrolled', shouldBeSolid);
    if (header) header.classList.toggle('ah-home-header-scrolled', shouldBeSolid);
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateHeaderState);
  }

  document.addEventListener('DOMContentLoaded', updateHeaderState);
  window.addEventListener('load', updateHeaderState, { passive: true });
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  updateHeaderState();
})();
